module.exports = __webpack_public_path__ + "static/media/3.430128f1.jpeg";